import React, { useEffect, useState } from "react";
import axiosInstance from "../services/axiosComman";

function useGetStatusData({ value,create=false }) {
  const [statusValue, setStatusValue] = useState([]);
  const [loading, setLoading] = useState(false);
  async function getData() {
    setLoading(true);
    await axiosInstance
      .get(`/Status/${value}/`)
      .then((res) => {
        let data = res?.data?.data;
        let xyz = [];
        if(create == true){
            setStatusValue(data);
        }else{
          data.forEach((i) => {
            let x = { label: i?.status_type, value: i?.status_type };
            xyz.push(x);
          });
          res?.data && setStatusValue(xyz);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }
  useEffect(() => {
    if (value) getData();
  }, [value]);
  return { statusValue, getData,loading };
}

export default useGetStatusData;
